export default __webpack_public_path__ + "static/media/jap-ecommerceImg_7.9b803694.webp";